module.exports = __webpack_public_path__ + "img/18.de5fae39.png";